module.exports = __webpack_public_path__ + "img/1.4afc33c8.png";